import { Injectable } from "@angular/core";
import { Rate } from "./model/Rate";
import { RateSubscription } from "./model/RateSubscription";
import { Product, Tenor } from "shared/cubiq-model-multi-asset";
import { Subject } from "rxjs";

export const CHANNEL_RATE: string = "RateChannel";

export interface IRateService {
  getRateEventSubject(): Subject<Array<Rate>>;

  getSpotRate(productCode: string): Promise<Rate>;

  getSpotRates(productCodes: Array<string>): Promise<Array<Rate>>;

  getRate(productCode: string, product: Product, tenor: Tenor, valueDate: Date): Promise<Rate>;

  getRates(rateSubscriptions: Array<RateSubscription>): Promise<Array<Rate>>;

  pauseStream(): Promise<void>;

  resumeStream(): Promise<void>;

  isStreamingPaused(): Promise<boolean>;
}
